/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkPackageTypeRequest } from '../../models/create-work-package-type-request';
import { WorkPackageTypeDto } from '../../models/work-package-type-dto';

export interface CreateWorkPackageType$Params {
      body: CreateWorkPackageTypeRequest
}

export function createWorkPackageType(http: HttpClient, rootUrl: string, params: CreateWorkPackageType$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageTypeDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackageType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageTypeDto>;
    })
  );
}

createWorkPackageType.PATH = '/v0/workPackageTypes/{id}';
